import { ApolloProvider } from '@apollo/client';
import { BrowserRouter, Route } from 'react-router-dom';
import { ModalProvider } from 'react-modal-hook';
import { Suspense } from 'react';

import { TrackingProvider } from '../common/Tracking';
import { client } from '../api/apollo';
import CookieConsentProvider from '../common/Common/CookieConsentProvider';
import EmbedProvider, { isEmbedded } from './Common/EmbedProvider';
import EventProvider from './Common/EventProvider';
import GlobalStyle from '../common/GlobalStyle';
import Main from './Main';
import RollbarProvider from '../common/Common/RollbarProvider';
import StateProvider from './Checkout/StateProvider';
import ThemeProvider from '../common/Common/ThemeProvider';
import UI from '../common/UI';
import config from './config';

const embedded = isEmbedded();

const App = () => (
  <RollbarProvider>
    <ThemeProvider options={embedded ? { bodyBackground: 'transparent' } : undefined}>
      <GlobalStyle />
      <Suspense fallback={<UI.PageLoader />}>
        <CookieConsentProvider>
          <ApolloProvider client={client}>
            <ModalProvider>
              <BrowserRouter basename={config.appUrl}>
                <Route
                  path="/:eventId?/:step?"
                  render={({ match: { params: { eventId, step } } }) => (
                    <TrackingProvider defaultPayload={{ tag: eventId, event: eventId, embedded }}>
                      <EmbedProvider eventId={eventId} step={step as any}>
                        <StateProvider
                          eventId={eventId}
                          step={step as any}
                          // Use a key to reset all checkout state when the event ID changes.
                          // Important when the event website links to multiple events from one page.
                          key={eventId}
                        >
                          <EventProvider eventId={eventId}>
                            <Main />
                          </EventProvider>
                        </StateProvider>
                      </EmbedProvider>
                    </TrackingProvider>
                  )}
                />
              </BrowserRouter>
            </ModalProvider>
          </ApolloProvider>
        </CookieConsentProvider>
      </Suspense>
    </ThemeProvider>
  </RollbarProvider>
);

export default App;
